import api, { ApiResponse } from './api';

import { City } from 'entities/City';
import { State, StateCityListProps } from 'entities/State';

interface GetStateListResponse {
  success: boolean;
  data: State[];
}

export const getStateListService = (): ApiResponse<GetStateListResponse> =>
  api({
    method: 'GET',
    url: 'states',
    useToken: true,
  });

interface GetStateCityListReponse {
  success: boolean;
  data: City[];
}

export const getStateCityListService = ({
  stateId,
}: StateCityListProps): ApiResponse<GetStateCityListReponse> =>
  api({
    method: 'GET',
    url: `states/${stateId}/cities`,
    useToken: true,
  });

interface GeocodeResponse {
  success: boolean;
  data: { lat: number; long: number };
}

export const geocodeCityService = (
  cityId: number
): ApiResponse<GeocodeResponse> =>
  api({
    method: 'GET',
    url: `states/cities/${cityId}/geocode`,
    useToken: true,
  });
